module.exports = __webpack_public_path__ + "static/media/logo.f8eb8234.svg";